import DeleteConfirm from "@/components/DeleteConfirm";
import { pluralRu } from "@/lib/plural";
import { settleForeignOutbox } from "@/lib/syncEngine";
import { signOut } from "@/lib/signOut";
import { useForeignOutbox } from "@/stores/foreignOutbox";

const UNSENT_FORMS = ["неотправленное изменение", "неотправленных изменения", "неотправленных изменений"] as const;

export default function ForeignOutboxConfirm() {
  const count = useForeignOutbox((s) => s.count);
  if (count === null) return null;

  return (
    <DeleteConfirm
      title={`На этом устройстве ${count} ${pluralRu(count, UNSENT_FORMS)} другого аккаунта. Удалить их?`}
      body="Отмена — выйти и сохранить их до входа в тот аккаунт."
      dismissible={false}
      onConfirm={() => void settleForeignOutbox(true)}
      onCancel={() => {
        void settleForeignOutbox(false);
        signOut();
      }}
    />
  );
}
